import React, { FC } from 'react';

import ReadingsDetailPage from "@/components/readings/ReadingsDetailPage";
import { Medium } from "@/constants/mediums";

const HeatReadingsDetailPage: FC = () => {
  return <ReadingsDetailPage medium={Medium.heat} />;
};

export default HeatReadingsDetailPage;
